// 全域 toast 渲染 — 掛在 Layout, 右下角堆疊, 2.5 秒自動消失 (lib/toast.ts)。
import { useToasts } from '../lib/toast.ts';

export function Toaster() {
  const items = useToasts((s) => s.items);
  const remove = useToasts((s) => s.remove);
  if (items.length === 0) return null;
  return (
    <div className="fixed bottom-4 right-4 z-[100] space-y-2 pointer-events-none">
      {items.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => remove(t.id)}
          className={`pointer-events-auto block w-full text-left text-white text-sm px-4 py-2.5 rounded-lg shadow-lg ${
            t.variant === 'error' ? 'bg-red-700' : 'bg-slate-900'
          }`}
        >
          {t.variant === 'error' ? '⚠' : '✓'} {t.message}
        </button>
      ))}
    </div>
  );
}
